import domReady from '@wordpress/dom-ready';
import './lib/carousel';

domReady(function() {
  newFlickity(
    '.carousel-list--employee',
    {
      contain: true,
      groupCells: true,
      pageDots: true,
      imagesLoaded: true,
      prevNextButtons: true,
    },
    (el) => {},
    true
  );
});
